import Vue from 'vue'
import Element from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import locale from 'element-ui/lib/locale/lang/en';
import App from './App.vue'
import router from './router'
import '@css/index.less'
import VueMeta from 'vue-meta'

// 禁用生产环境提示
Vue.config.productionTip = false
// Element挂载到Vue
Vue.$message = Element.Message
Vue.use(Element,{ locale })
Vue.use(VueMeta)

new Vue({
  router,
  render: (h) => h(App),
  // /* 这句非常重要，否则预渲染将不会启动 */
  // mounted () {
  //   document.dispatchEvent(new Event('render-event'))
  // }
}).$mount('#app')
